import ModerationActivitiesList from "./ModerationActivitiesList";
import HistoryIcon from "@mui/icons-material/History";

export const ModerationActivitiesIcon = HistoryIcon;
export { ModerationActivitiesList };
